import { useSupabaseLeaderboard } from './useSupabaseLeaderboard';
import type { User } from '../types/user';

export function usePoints() {
  const { updatePoints } = useSupabaseLeaderboard();

  const handlePointsUpdate = async (user: User | null, amount: number) => {
    if (!user) return;
    
    const newPoints = user.points + amount;
    
    try {
      // Update points in Supabase first
      await updatePoints(user.username, user.walletAddress, newPoints);
      
      // Only update local state if Supabase update succeeds
      user.points = newPoints;
      localStorage.setItem('kingdom-user', JSON.stringify(user));
    } catch (error) {
      console.error('Failed to update points:', error);
    }
  };

  return { updatePoints: handlePointsUpdate };
}